import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { auth, db } from  '../../../firebase/Firebase';
import DeliveryCard from './DeliveryCard';

const DeliveryFeed = ({ startDate, endDate, stage }) => {
  const [deliveries, setDeliveries] = useState([]);
  const navigate = useNavigate();
  const userEmail = auth.currentUser.email
  const orgId = localStorage.getItem('orgId');

  useEffect(() => {
    let deliveryQuery = query(
      collection(db, 'Deliveries'),
      where('orgId', '==', orgId),
      where('deliveryStage', '==', stage),
      orderBy('deliveryDate', 'desc')
    );

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      deliveryQuery = query(
        deliveryQuery,
        where('deliveryDate', '>=', start),
        where('deliveryDate', '<=', end)
      );
    }

    if (stage) {
      deliveryQuery = query(deliveryQuery, where('deliveryStage', '==', stage));
    }

    const unsubscribe = onSnapshot(deliveryQuery, (snapshot) => {
      const deliveryData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setDeliveries(deliveryData);
    });

    return () => unsubscribe();

  }, [userEmail, startDate, endDate, stage]);

  const handleCardClick = (delivery) => {
    console.log("Navigating to:", `/delivery/${delivery.id}`);
    navigate(`/dashboard/delivery/${delivery.id}`, { state: { delivery } });
  };



  const feedContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const cardStyle = {
    margin: '10px 0'
  };

  return (
    <div style={feedContainerStyle}>
      {deliveries.map(delivery => (
        <div style={cardStyle} key={delivery.id}>
          <DeliveryCard data={delivery} onClick={() => handleCardClick(delivery)} />
        </div>
      ))}
    </div>
  );
};

export default DeliveryFeed;

